<p-sidebar
  [(visible)]="visible"
  position="right"
  styleClass="w-screen lg:w-4"
  (onShow)="onShow()"
  (onHide)="onHide()"
>
  <!-- Start::header sidebar-->
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-3">
      @if(step() === 2 && addresses.length && sessionService.isLoggedIn()){
      <!-- Start::botón retroceso -->
      <i
        class="fa-sharp fa-solid fa-angle-left text-xl cursor-pointer"
        style="padding-top: 1px"
        (click)="step.set(1)"
      ></i>
      <!-- End::botón retroceso -->
      }
      <!-- Start::título -->
      <span class="font-bold text-lg">
        {{
          step() === 1 ? 'Seleccione una dirección' : 'Nueva dirección'
        }}</span
      >
      <!-- End::título -->
    </div>
  </ng-template>
  <!-- End::header sidebar-->

  <!-- Start::content sidebar -->
  <ng-template pTemplate="content">
    @if(step() === 1){
    <!-- Start::listado de direcciones -->
    <form [formGroup]="selectedAddressForm">
      <div class="flex flex-column field p-0 gap-3">
        @for(item of addresses; track item.id ;) {
        <div
          class="flex p-3 border-round border-1 surface-border w-full cursor-pointer flex align-items-center justify-content-between md:min-h-6rem"
          (click)="onSelectAddress($index)"
          [ngClass]="{
            'surface-border hover:border-400': idField.value !== item.id,
            'border-primary bg-blue-50': idField.value === item.id
          }"
        >
          <div class="flex">
            <p-radioButton
              name="id"
              [value]="item.id"
              formControlName="id"
              styleClass="mr-3"
            />
            <div>
              <div
                class="font-semibold mb-1 uppercase"
                style="text-transform: uppercase"
              >
                {{ item.address }}
              </div>
              <span class="text-sm">{{ item.city }}</span>
            </div>
          </div>
          <p-button
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            [rounded]="true"
            class="delete-button"
            (click)="confirmDeleteAddress($event, $index)"
            [disabled]="blockUiService.blocked()"
          />
        </div>
        }
      </div>
    </form>
    <!-- End::listado de direcciones -->
    } @else if(step() === 2){
    <!-- Start::formulario para crear dirección -->
    <form
      #addressFormElement
      [formGroup]="addressForm"
      (ngSubmit)="onSubmitAddressForm()"
    >
      <app-address-form-control-container />
    </form>
    <!-- End::formulario para crear dirección -->
    }
  </ng-template>
  <!-- End::content sidebar -->

  <!-- Start::footer sidebar -->
  <ng-template pTemplate="footer">
    <div class="flex flex-column gap-2 md:gap-3">
      @if(step() === 1){
      <p-button
        label="Agregar otra dirección"
        class="w-full"
        styleClass="w-full"
        [outlined]="true"
        (onClick)="step.set(2)"
        [disabled]="blockUiService.blocked()"
      />
      <p-button
        label="Seleccionar"
        class="w-full"
        styleClass="w-full"
        (onClick)="selectAddressSubmit()"
        [disabled]="blockUiService.blocked()"
      />
      } @else if(step() === 2){
      <p-button
        label="Guardar"
        class="w-full"
        styleClass="w-full"
        (onClick)="onCreateAddressSubmit()"
        [disabled]="blockUiService.blocked()"
      />
      }
    </div>
  </ng-template>
  <!-- End::footer sidebar -->
</p-sidebar>

<!-- Start::toast de error o éxito -->
<p-toast />
<!-- End::toast de error o éxito -->

<!-- Start::diálogo de confirmación de eliminación -->
<p-confirmDialog />
<!-- End::diálogo de confirmación de eliminación -->
